import fasad from './fasad.jpg'

export { fasad }



// WEBPACK FOOTER //
// ./src/features/Contacts/components/Contacts/images/index.js